export default __webpack_public_path__ + "static/conTrac1-cd9654880e8aeaef5a7b7f5c650f923d.jpg";